module.exports = __webpack_public_path__ + "./fonts/64a1d4a533c220c39be9257d3e95ab40.ttf";